//Изменяет булевое значение атрибута на противоположное
export function toggleAttr(element, attrName) {
  if (element.getAttribute(attrName) === 'true')
    element.setAttribute(attrName, 'false');
  else element.setAttribute(attrName, 'true');
}

//Возвращает имя браузера
export function getBrowserName() {
  const agent = window.navigator.userAgent.toLowerCase();
  const browser =
    agent.indexOf('edge') > -1
      ? 'edge'
      : agent.indexOf('edg') > -1
      ? 'chromium based edge'
      : agent.indexOf('opr') > -1 && window.opr
      ? 'opera'
      : agent.indexOf('chrome') > -1 && window.chrome
      ? 'chrome'
      : agent.indexOf('trident') > -1
      ? 'ie'
      : agent.indexOf('firefox') > -1
      ? 'firefox'
      : agent.indexOf('safari') > -1
      ? 'safari'
      : 'other';

  return browser;
}

export function getOS() {
  let userAgent = window.navigator.userAgent.toLowerCase(),
    macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
    windowsPlatforms = /(win32|win64|windows|wince)/i,
    iosPlatforms = /(iphone|ipad|ipod)/i,
    os = null;

  if (macosPlatforms.test(userAgent)) {
    os = 'macos';
  } else if (iosPlatforms.test(userAgent)) {
    os = 'ios';
  } else if (windowsPlatforms.test(userAgent)) {
    os = 'windows';
  } else if (/android/.test(userAgent)) {
    os = 'android';
  } else if (!os && /linux/.test(userAgent)) {
    os = 'linux';
  }

  return os;
}

/**
 * Склонение числительных
 * @number количество
 * @one склонение для одного
 * @two склонение для двух
 * @five склонение для пяти
 * */
export function plural(number, one, two, five) {
  if (number % 10 === 1 && number % 100 !== 11) {
    return one;
  } else if (
    number % 10 >= 2 &&
    number % 10 <= 4 &&
    (number % 100 < 10 || number % 100 >= 20)
  ) {
    return two;
  } else {
    return five;
  }
}

/**
 * Вывод цены со знаком валюты
 * @price цена
 * @currencySign знак валюты
 * @cSignBefore ставить ли знак валюты перед ценой
 * */
export function displayPrice(price, currencySign, cSignBefore) {
  return `${cSignBefore ? currencySign : ''}${price}${
    !cSignBefore ? '\u00A0' + currencySign : ''
  }`;
}

/**
 * Проверяет, что страница открыта в iframe
 * */
export function inIFrame() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
